import Link from 'next/link';
import { useEffect, useState } from 'react';

import { EMAIL_REGEX } from '@app/libs/services/Validation';
import { cn } from '@app/libs/utils';
import { authService } from '@app/services/auth.service';

import GCaptcha from '../GCaptcha';
import { Button } from '../ui/Button';
import { useToast } from '../ui/Toast';

interface ForgotPasswordComponentProps {
  className?: string;
  onForgotPassword?: (...args: any[]) => void;
}

export const ForgotPasswordComponent: React.FC<ForgotPasswordComponentProps> = ({
  className,
  onForgotPassword,
}) => {
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [captchaPassed, setCaptchaPassed] = useState(false);
  const [forgotPasswordDisable, setForgotPasswordDisable] = useState(true);

  const validateForm = () => {
    if (email.trim() === '' || !EMAIL_REGEX.test(email) || !captchaPassed) {
      setForgotPasswordDisable(true);
    } else {
      setForgotPasswordDisable(false);
    }
  };

  useEffect(() => {
    validateForm();
  }, [captchaPassed, email]);

  const handleForgotPassword = async () => {
    try {
      const { success, errors } = await authService.otp(email);
      if (success) {
        onForgotPassword?.(email);
      } else {
        toast.error(errors?.message || `Không gửi được OTP đến email ${email}`);
      }
    } catch {
      toast.error(`Không gửi được OTP đến email ${email}`);
    }
  };

  return (
    <div className={cn('max-w-[90vw] w-160 p-5 flex flex-col gap-20', className)}>
      <div className="flex flex-col gap-4 items-center">
        <h2 className="text-3xl font-bold">Quên mật khẩu</h2>
        <p>
          Đã có mật khẩu?{' '}
          <Link href="/auth/login" className="underline hover:text-blue-800 transition-all">
            Đăng nhập ngay
          </Link>
        </p>
      </div>

      <form className="flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <div className="flex justify-between gap-2">
            <label htmlFor="email">Email của bạn</label>
          </div>
          <input
            type="email"
            id="email"
            name="email"
            className="w-full border border-gray-300 rounded-xl py-2 px-5 h-14"
            autoComplete="email"
            placeholder="Nhập email của bạn"
            onChange={e => setEmail(e.target.value)}
          />
        </div>

        <div className="flex flex-col justify-center mt-5 gap-4">
          <GCaptcha
            className="w-full flex justify-center"
            onVerify={() => {
              setCaptchaPassed(true);
            }}
            onExpired={() => {
              setCaptchaPassed(false);
            }}
            onError={() => {
              setCaptchaPassed(false);
            }}
            onNoCaptcha={() => {
              setCaptchaPassed(true);
            }}
          />
          <Button
            type="button"
            className={cn(
              'w-full bg-blue-500 text-white rounded-xl py-2 px-5 h-14',
              forgotPasswordDisable ? 'bg-gray-400 cursor-not-allowed' : 'cursor-pointer',
              'transition-all'
            )}
            disabled={forgotPasswordDisable}
            onClick={handleForgotPassword}
            loadingText="Đang gửi..."
          >
            Tiếp tục
          </Button>
        </div>
      </form>
    </div>
  );
};
